// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/InviteYourColleague/Handlers/SetFieldValue";
import { InviteYourColleagueFormContext } from "@store/Library/Widgets/InviteYourColleague/InviteYourColleagueForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
    jobTitleOptions = "jobTitleOptions",
    jobTitle = "jobTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
        [fields.jobTitleOptions]: {
            fields: {
                [fields.jobTitle]: string;
            };
        }[];
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    jobTitle: state.greif.components.inviteYourColleagueForm.fieldValues["jobTitle"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface JobTitleStyles {
    jobTitleSelect?: SelectPresentationProps;
}

export const jobTitleStyles: JobTitleStyles = {};

const styles = jobTitleStyles;

const JobTitle: FC<Props> = ({ fields, jobTitle, setFieldValue }) => {
    const { isRequired, fieldLabel, jobTitleOptions } = fields;
    const inviteYourColleagueFormContext = useContext(InviteYourColleagueFormContext);
    const [jobTitleErrorMessage, setJobTitleErrorMessage] = useState("");

    useEffect(() => {
        if (typeof jobTitle === "undefined") {
            setFieldValue({ key: "jobTitle", value: "default" });
        }
    }, [jobTitle]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.jobTitle = validateJobTitle;
        if (typeof jobTitle !== "undefined" || jobTitle !== "default") {
            validateJobTitle();
        }
    }, [jobTitle]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.jobTitle = validateJobTitle;
    }, [isRequired]);

    const validateJobTitle = () => {
        const errorMessage = isRequired && !jobTitle ? (translate(`${fieldLabel} is required`) as string) : "";
        setJobTitleErrorMessage(errorMessage);
        return !errorMessage;
    };

    const jobTitleChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
        setFieldValue({ key: "jobTitle", value: event.target.value });
    };

    return (
        <Select
            // eslint-disable-next-line spire/avoid-dynamic-translate
            label={translate(fieldLabel)}
            placeholder={translate("Select a job title")}
            required={isRequired}
            value={String(jobTitle)}
            onChange={jobTitleChangeHandler}
            error={jobTitleErrorMessage}
            {...styles.jobTitleSelect}
        >
            <option value="default" disabled>
                {translate("Select a job title")}
            </option>

            {jobTitleOptions.length > 0 &&
                jobTitleOptions.map((x, index) => (
                    <option value={x.fields.jobTitle} key={index}>
                        {
                            // eslint-disable-next-line spire/avoid-dynamic-translate
                            translate(x.fields.jobTitle || "")
                        }
                    </option>
                ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(JobTitle),
    definition: {
        displayName: "Job Title",
        group: constants.widgetGroup.inviteYourColleague,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Your Colleague's Job Title",
                fieldType: "Translatable",
            },
            {
                name: fields.jobTitleOptions,
                displayName: "Job Title Options",
                editorTemplate: "ListField",
                getDisplay: item => {
                    return item.fields.jobTitle;
                },
                defaultValue: [
                    {
                        fields: {
                            jobTitle: "Accounts Payable",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Administrative assistant",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Buyer",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Buyer's assistant",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Quality Control",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Planner",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Plant manager",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Production",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Supply chain",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Warehouse manager",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Sustainability / Recycling",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Office coordinator",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Office manager",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Owner of business",
                        },
                    },
                    {
                        fields: {
                            jobTitle: "Other",
                        },
                    },
                ],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "jobTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
